import { c as _c } from "react/compiler-runtime";
import { ROOT_FONT_ID, StoreFontEnum, getSingleFontPreviewCssString, useDesignContext } from '@systemeio/digital-store-shared';
import { FormSelect } from '@systemeio/ui';
import React, { ReactNode, useMemo } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export function StoreFontPicker() {
  const $ = _c(20);
  const {
    t
  } = useLocoTranslation();
  const {
    state,
    setState
  } = useDesignContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.entries(StoreFontEnum).map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const fontsData = t0;
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.store.theme.primary_font");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setState) {
    t2 = data => data && setState(prev => ({
      ...prev,
      primaryFont: data
    }));
    $[3] = setState;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== state.primaryFont || $[6] !== t1 || $[7] !== t2) {
    t3 = <FormSelect withoutCloseIcon={true} label={t1} containerClassName="w-fit" className="w-44 lg:min-w-0" optionsClassName="z-50" data={fontsData} value={state.primaryFont} onChange={t2} />;
    $[5] = state.primaryFont;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("dashboard.store.theme.secondary_font");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== setState) {
    t5 = data_0 => data_0 && setState(prev_0 => ({
      ...prev_0,
      secondaryFont: data_0
    }));
    $[11] = setState;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== state.secondaryFont || $[14] !== t4 || $[15] !== t5) {
    t6 = <FormSelect withoutCloseIcon={true} label={t4} className="w-44 lg:min-w-0" optionsClassName="z-50" data={fontsData} value={state.secondaryFont} onChange={t5} />;
    $[13] = state.secondaryFont;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t6) {
    t7 = <div className="flex items-center gap-3">{t3}{t6}</div>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(t0) {
  const [caption, id] = t0;
  const customCaption = <span style={{
    fontFamily: id
  }}>{caption}</span>;
  const fontPreviewStyle = document.createElement("style");
  const previewId = `${ROOT_FONT_ID}-${id}`;
  fontPreviewStyle.id = previewId;
  const existingFontStyle = document.getElementById(previewId);
  if (existingFontStyle) {
    existingFontStyle.remove();
  }
  const fontPreviewCss = getSingleFontPreviewCssString({
    fontFamily: id
  });
  fontPreviewStyle.append(fontPreviewCss);
  document.head.append(fontPreviewStyle);
  return {
    id,
    caption,
    customCaption
  };
}